export const Services = ({ }: {}) => {
    return (
        <>
            <section className={`mt-14 lg:mt-4`}>
                <div className="flex flex-col gap-4 px-3 md:w-[95%] lg:px-0 max-w-7xl mx-auto" data-aos="fade-up">
                    <h2 className="font-bold text-3xl lg:text-2xl text-stone-700 text-center uppercase mb-6 lg:mb-5">Pourquoi Choisir Nos Offres Fibre + Mobile ?</h2>
                    <div className="grid grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-6">
                        <div className="text-lg lg:text-[18px] lg:leading-7 bg-secondaryNewComparateurFibre flex items-start justify-between gap-4 py-6 px-4 rounded-lg">
                            <span className="bg-orange-500 w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="flex-shrink-0 w-7 h-6 text-white">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>

                            <p>Profitez de tarifs avantageux sans sacrifier la qualité de votre connexion et de votre forfait mobile.
                            </p>
                        </div>
                        <div className="text-lg lg:text-[18px] lg:leading-7 bg-secondaryNewComparateurFibre flex items-start justify-between gap-4 py-6 px-4 rounded-lg">
                            <span className="bg-orange-500 w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="flex-shrink-0 w-7 h-6 text-white">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>

                            <p>Bénéficiez d'un service fiable et performant, idéal pour le télétravail, le streaming, les jeux en ligne, et vos appels mobiles.
                            </p>
                        </div>
                        <div className="text-lg lg:text-[18px] lg:leading-7 bg-secondaryNewComparateurFibre flex items-start justify-between gap-4 py-6 px-4 rounded-lg">
                            <span className="bg-orange-500 w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="flex-shrink-0 w-7 h-6 text-white">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>

                            <p>Trouvez facilement l'offre combinée qui correspond à vos besoins spécifiques, avec des contrats sans engagement.
                            </p>
                        </div>
                        <div className="text-lg lg:text-[18px] lg:leading-7 bg-secondaryNewComparateurFibre flex items-start justify-between gap-4 py-6 px-4 rounded-lg">
                            <span className="bg-orange-500 w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="flex-shrink-0 w-7 h-6 text-white">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>

                            <p>Aucun frais caché. Nos offres sont claires et transparentes, vous savez exactement ce que vous payez.
                            </p>
                        </div>

                    </div>
                    <div className="text-center w-full mt-9 lg:mt-6">
                        <a href="#top" className="bg-primaryNewComparateurFibre text-center text-white font-medium py-4 px-12 lg:py-5 hover:text-primaryNewComparateurFibre hover:border-primaryNewComparateurFibre hover:border-2 hover:font-bold hover:ease-linear hover:duration-300 hover:bg-white text-lg lg:text-xl rounded-full">COMPARER MAINTENANT !</a>
                    </div>
                </div>
            </section>
        </>
    );
};
